import { NJModal, NJModalContent, NJButton } from '@engie-group/fluid-design-system-react';

function ModalConfirmDelete({ isOpen,id,  gid, handleDelete, handleCancel }) {

 
     return (
        <NJModal
            id="modalConfirmDelete"
            isOpen={isOpen}
        >
            <NJModalContent
                footer={
                    <>
                        <NJButton
                            emphasis="bold"
                            variant="secondary"
                            label="Cancel"
                            onClick={handleCancel}
                        />
                        <NJButton
                            label="Delete"
                            icon="person_remove"
                            iconClassName="material-icons-outlined"   
                            variant="destructive"                        
                            onClick={() => { handleDelete(id) }}
                        />
                    </>
                }
                icon="person_add_alt"
                id="modalConfirmDelete"
                onClose={handleCancel}
                title={'Confirm admin user deletion'}
            >
               <p>Confirm that you want to remove <b>{gid}</b> from admin users.</p>
            </NJModalContent>
        </NJModal>
    )
}

export default ModalConfirmDelete;
